import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import { getUserAddress } from '../services/Kyc'
import { addressActions } from '../store/slices/Address'
import { IStore } from '../interfaces/Store'
import { STATUS } from '../enums/common'
import { IAddressSlice } from '../interfaces/Address'
import { handleError } from '../services/utils'

const UserAddressHook = (): IAddressSlice => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { status: parcoursStatus, address: parcoursAddress } = useSelector(
    (state: IStore) => state.parcoursAddressReducer
  )

  const { status, address } = useSelector(
    (state: IStore) => state.addressReducer
  )

  useEffect(() => {
    async function getAddress() {
      dispatch(addressActions.addressLoading())
      try {
        const response = await getUserAddress()
        // @ts-ignore
        dispatch(addressActions.addressReceived(response))
      } catch (e) {
        dispatch(addressActions.addressFailed())
        handleError(e, history)
      }
    }

    if (parcoursStatus === STATUS.idle && status === STATUS.idle) {
      getAddress()
    }
    // eslint-disable-next-line
  }, [dispatch, status])

  return { status, address: parcoursAddress || address }
}

export default UserAddressHook
